// extracted by mini-css-extract-plugin
export default {"pageTransition":"PageTransition_pageTransition__hpNgI"};